export const enum Role {
  Administrator = 'administrator',
  FinanceManager = 'finance_manager',
  CheckRunManager = 'check_run_manager',
  CheckRun = 'check_run',
  AccountExecutive = 'account_executive',
  AccountAdministrator = 'account_administrator',
  AccountManager = 'account_manager',
  CallCenter = 'call_center',
  Claims = 'claims',
  EPayablesManager = 'epayables_manager',
  AccountsPayable = 'accounts_payable',
  AccountsReceivable = 'accounts_receivable'
}

export const roleNameMap: Record<Role, string> = {
  [Role.Administrator]: 'Administrator',
  [Role.FinanceManager]: 'Finance Manager',
  [Role.CheckRunManager]: 'Check Run Manager',
  [Role.CheckRun]: 'Check Run',
  [Role.AccountExecutive]: 'Account Executive',
  [Role.AccountAdministrator]: 'AE/AM Administrator',
  [Role.AccountManager]: 'Account Manager',
  [Role.CallCenter]: 'Call Center',
  [Role.Claims]: 'Claims',
  [Role.EPayablesManager]: 'EPayables Manager',
  [Role.AccountsPayable]: 'Accounts Payable',
  [Role.AccountsReceivable]: 'Accounts Receivable'
}

export const roleColorMap: Record<string, string> = {
  administrator: 'magenta',
  account_executive: 'red',
  account_manager: 'green',
  call_center: 'purple',
  check_run: 'orange',
  check_run_manager: 'volcano',
  claims: 'lime',
  finance_manager: 'blue',
  accounts_payable: 'gold',
  accounts_receivable: 'cyan'
}

export const roleCodeMap: Record<Role, string> = {
  [Role.Administrator]: 'ADM',
  [Role.FinanceManager]: 'FIN',
  [Role.CheckRunManager]: 'CRM',
  [Role.CheckRun]: 'CHK',
  [Role.AccountExecutive]: 'AEX',
  [Role.AccountAdministrator]: 'AAD',
  [Role.AccountManager]: 'AMG',
  [Role.CallCenter]: 'CAL',
  [Role.Claims]: 'CLM',
  [Role.EPayablesManager]: 'EPA',
  [Role.AccountsPayable]: 'APY',
  [Role.AccountsReceivable]: 'ARC'
}
